import {contacts} from './contacts';
import {httpUtil} from './httpUtil';
import { rewards } from './rewards';
import { config } from './config';
import { account } from './account';
import { communications } from './communications';
import { orders } from './orders';
import { products } from './products';
import { organisations } from './organisations';
// import { dataUtil } from './dataUtil';
// import { merchant } from './merchant';
import { jcccards } from './jcccardhash';
import { paymentgateway } from './paymentgateway';
import { wifi } from './wifi';
// import { cignalservices } from './cignalservices';
import { printout } from './printout';
import { subscriptions } from './subscriptions';
export default {
  contacts: contacts,
  rewards: rewards,
  config: config,
  account: account,
  communications: communications,
  orders: orders,
  products: products,
  organisations:organisations,
  jcccards:jcccards,
  setupChannel: httpUtil.setupChannel,
  getSession : httpUtil.getSession,
  startSession: httpUtil.startSession,
  cleanSession: httpUtil.startSession,
  // dataUtil: dataUtil,
  // merchant: merchant,
  paymentgateway: paymentgateway,
  wifi: wifi,
  // cignalservices:cignalservices,
  printout:printout,
  subscriptions: subscriptions,
}